export { METIER_RULES, detectMetier } from './metiers-des-articles';

export function remiseClient(cl, ref) {
  const r = (cl && cl.remises) || {};
  return Object.prototype.hasOwnProperty.call(r, ref)
    ? +r[ref] || 0
    : +(cl && cl.remiseGlobale) || 0;
}

export function remiseLigne(cl, ref, mag) {
  const r = (cl && cl.remises) || {};
  if (Object.prototype.hasOwnProperty.call(r, ref)) return +r[ref] || 0;
  return mag ? +(cl && cl.remiseGlobale) || 0 : 0;
}

/**
 * La remise que le client choisi donne à une ligne, au moment où on le choisit
 * pour la pièce : sa remise sur l'article, sinon celle écrite sur la ligne,
 * sinon (magasin) sa remise générale.
 *
 * @param {object} cl client
 * @param {object} l ligne
 * @param {boolean} mag pièce du magasin
 * @returns {number} la remise, en %
 */
export function remiseDuClient(cl, l, mag) {
  if (!l || !l.ref) return +(l && l.rem) || 0;
  const r = (cl && cl.remises) || {};
  if (Object.prototype.hasOwnProperty.call(r, l.ref)) return +r[l.ref] || 0;
  const man = +l.rem || 0;
  if (man > 0) return man;
  return mag ? +(cl && cl.remiseGlobale) || 0 : 0;
}

/**
 * La remise d'une ligne telle qu'elle est enregistrée sur la pièce. Une offre
 * ou une facture déjà faite ne bouge pas quand le patron change ensuite les
 * remises du client : l'écran la recalculait aux remises du jour, et sa
 * feuille A4 ne disait plus le prix de son QR-facture.
 *
 * @param {object} l ligne
 * @returns {number} la remise, en %
 */
export function remEff(l) {
  return +(l && l.rem) || 0;
}

export function encCmd(o) {
  try {
    return 'STCMD' + btoa(encodeURIComponent(JSON.stringify(o)));
  } catch (e) {
    return '';
  }
}

export function decCmd(s) {
  try {
    const b = (s || '').trim().replace(/^STCMD/, '');
    return JSON.parse(decodeURIComponent(atob(b)));
  } catch (e) {
    return null;
  }
}
